import React, { useState } from 'react';
import { useLocation } from 'react-router';
import Users from 'components/business/Users';
import UserDetails from '../components/business/users/UserDetails';

export const UsersCtx = React.createContext({});

function UsersPageProvider(props) {
  const [ search, setSearch ] = useState('');
  const [ users, setUsers ] = useState(undefined);

  const ctx = {
    search,
    setSearch,
    users,
    setUsers,
  };
  return (
    <UsersCtx.Provider value={ ctx }>
      {props.children}
    </UsersCtx.Provider>
  );
}

function UsersPage() {
  const location = useLocation();

  const { search } = location;
  const params = new URLSearchParams(search);
  const id = params.get('id');

  //  edw tha mpei sto prwto user ena component to opoio tha to pw UserDetails
  // kati san to DoctorDetails kai to Thematic Package Details
  return (
    <UsersPageProvider>
      { id ? <UserDetails id={ id } /> : <Users /> }
    </UsersPageProvider>
  );
}

export default UsersPage;
